@if ((uniqueMarkers$ | async).length > 0) {
  <div class="filter-container comment-filter-marker" [formGroup]="form">
    <mat-form-field goSelect>
      <mat-label>{{ 'library-collections_add-markers' | translate }}</mat-label>
      <mat-select
        multiple
        formControlName="selectedMarkers"
        disableOptionCentering
        [placeholder]="'marker-filter-dropdown-placeholder' | translate"
        panelClass="offsetPanel markerFilterPanel">
        <mat-select-trigger>
          <!-- need this class for goSelect prepend label -->
          <span class="mat-mdc-select-min-line">
            @if (allSelected.selected) {
              <span>{{ 'common_all' | translate }}</span>
            } @else {
              <span class="num-selected-badge">{{ form.value.selectedMarkers.length }}</span>
            }
          </span>
        </mat-select-trigger>
        <mat-option
          #allSelected
          (click)="toggleAll()"
          [value]="0">
          {{ 'common_all' | translate}}
        </mat-option>
        @if (aiMarkers.length) {
          <mat-divider></mat-divider>
        }
        @if (aiMarkers.length) {
          <mat-optgroup [label]="'activity-editor-new_ai-markers-modal-ai-markers' | translate" class="ai-marker-group">
            @for (marker of aiMarkers; track marker) {
              <mat-option
                (click)="toggleOne()"
                [value]="marker.tag_id">
                <span class="marker-with-count">
                  <marker
                    [marker]="marker"
                    [aiStyle]="true"
                    [withName]="true"
                    [matTooltip]="marker.tag_name"
                  matTooltipPosition="above"></marker>
                  <small>({{ marker.count }})</small>
                </span>
              </mat-option>
            }
          </mat-optgroup>
        }
        @if (activityMarkers.length) {
          <mat-divider></mat-divider>
        }
        @if (activityMarkers.length) {
          <mat-optgroup [label]="'marker-filter-activity-markers' | translate" class="activity-marker-group">
            @for (marker of activityMarkers; track marker) {
              <mat-option
                (click)="toggleOne()"
                [attr.aria-label]="marker.tag_name + ' (' + marker.count + ')'"
                [value]="marker.tag_id">
                <span class="marker-with-count">
                  <marker [marker]="marker" [withName]="true"></marker>
                  <small>({{ marker.count }})</small>
                </span>
              </mat-option>
            }
          </mat-optgroup>
        }
      </mat-select>
      <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
    </mat-form-field>
  </div>
}
